import type { Messages } from './ru';

export const uz: Messages = {
  meta: { langName: 'Oʻzbekcha', short: 'UZ' },
  common: {
    tagline: 'Watch together. Feel closer.',
    createRoom: 'Xona yaratish',
    joinRoom: 'Xonaga kirish',
    join: 'Kirish',
    cancel: 'Bekor qilish',
    save: 'Saqlash',
    retry: 'Qayta urinish',
    home: 'Bosh sahifa',
    copy: 'Nusxalash',
    copied: 'Nusxalandi',
    close: 'Yopish',
    loading: 'Yuklanmoqda…',
    you: 'siz',
  },
  landing: {
    navHow: 'Qanday ishlaydi',
    navPrivacy: 'Maxfiylik',
    eyebrow: 'Birgalikda tomosha qilish xonalari',
    title: 'Birga tomosha qiling.\nUzoqda boʻlsangiz ham.',
    subtitle:
      'Bitta xona, bitta video, bitta soniya. Sinxron ijro, ovoz, kameralar va chat — roʻyxatdan oʻtmasdan va hech narsa oʻrnatmasdan.',
    quickJoinLabel: 'Taklif havolasi yoki xona kodi',
    quickJoinPlaceholder: 'Taklif havolasini qoʻying',
    quickJoinInvalid: 'Bu VYBE havolasiga oʻxshamaydi. Taklifni tekshiring.',
    demoLabel: 'VYBE xonasi shunday koʻrinadi',
    demoNowPlaying: 'Hozir xonada',
    demoSynced: 'Sinxronlangan',
    demoChat1: 'Shu lahza 🔥',
    demoChat2: 'Pauza qiling, hozir qaytaman',
    featuresTitle: 'Birgalikdagi oqshom uchun hamma narsa',
    features: [
      {
        title: 'Sinxron tomosha',
        text: 'Pauza, oʻtkazish va ijro hammada bir vaqtda. Server yagona holatni saqlaydi.',
      },
      {
        title: 'Ovoz va kameralar',
        text: 'Ishtirokchilar oʻrtasida toʻgʻridan-toʻgʻri WebRTC aloqasi. Kamera faqat siz bosganda yoqiladi.',
      },
      {
        title: 'Chat va reaksiyalar',
        text: 'Film davomida yozing va reaksiya bildiring — ekrandan uzilmasdan.',
      },
      {
        title: 'Deyarli har qanday havola',
        text: 'MP4, WebM, HLS, DASH, YouTube, Vimeo va joylashtiriladigan pleyerlar. VYBE turini oʻzi aniqlaydi.',
      },
    ],
    stepsTitle: 'Seansgacha uch qadam',
    steps: ['Xona yarating', 'Video havolasini qoʻying', 'Taklifni yuboring'],
    privacyTitle: 'Standart boʻyicha maxfiylik',
    privacy: [
      'Suhbatlar va kamera videolari ishtirokchilar oʻrtasida toʻgʻridan-toʻgʻri uzatiladi va hech qachon yozib olinmaydi.',
      'Maxfiy xonalar faqat kriptografik jihatdan mustahkam taklif havolasi orqali ochiladi.',
      'Roʻyxatdan oʻtish shart emas: mehmon profili faqat sessiya davomida yashaydi.',
      'VYBE videoni yuklab olmaydi va proksi qilmaydi — havola toʻgʻridan-toʻgʻri brauzeringizda ijro etiladi.',
    ],
    footer: 'VYBE — birgalikda tomosha qilish platformasi.',
    footerNote: 'Faqat koʻrish va koʻrsatish huquqingiz boʻlgan kontentdan foydalaning.',
  },
  create: {
    title: 'Yangi xona',
    description: 'Sozlamalarni keyinroq oʻzgartirish mumkin.',
    name: 'Xona nomi',
    namePlaceholder: 'Kino oqshomi',
    defaultName: 'Kino oqshomi',
    private: 'Maxfiy xona',
    privateHint: 'Faqat taklif havolasi orqali kirish',
    maxParticipants: 'Ishtirokchilar',
    control: 'Videoni boshqarish',
    controlHost: 'Faqat boshlovchi',
    controlShared: 'Barcha ishtirokchilar',
    voice: 'Ovozli chat',
    camera: 'Kameralar',
    submit: 'Yaratish',
    failed: 'Xona yaratilmadi. Ulanishni tekshirib, qayta urinib koʻring.',
  },
  name: {
    title: 'Sizni qanday chaqiraylik?',
    description: 'Ismingizni xonadagi boshqa ishtirokchilar koʻradi.',
    label: 'Ismingiz',
    placeholder: 'Masalan, Aziza',
    continue: 'Davom etish',
    invitedTo: 'Sizni xonaga taklif qilishdi',
    privateRoom: 'Maxfiy xona',
  },
  room: {
    connecting: 'Xonaga ulanmoqda…',
    reconnecting: 'Aloqa uzildi. Qayta ulanmoqda…',
    reconnected: 'Aloqa tiklandi',
    invite: 'Taklif qilish',
    inviteCopied: 'Taklif havolasi nusxalandi',
    leave: 'Chiqish',
    endRoom: 'Xonani yakunlash',
    endConfirm: 'Xona barcha ishtirokchilar uchun yakunlansinmi?',
    theater: 'Kinoteatr rejimi',
    exitTheater: 'Oddiy rejim',
    tabs: { chat: 'Chat', people: 'Ishtirokchilar', settings: 'Sozlamalar' },
    roles: { owner: 'Egasi', moderator: 'Moderator', participant: 'Ishtirokchi' },
    away: 'qayta ulanmoqda',
    makeModerator: 'Moderator qilish',
    removeModerator: 'Moderatorlikdan olish',
    kick: 'Xonadan chiqarish',
    hostControls: 'Videoni boshlovchi boshqaradi',
    sharedControls: 'Hamma boshqara oladi',
    settingsSaved: 'Sozlamalar saqlandi',
    errors: {
      not_found: { title: 'Xona topilmadi', text: 'Ehtimol, u yakunlangan yoki havola eskirgan.' },
      invalid_invite: {
        title: 'Taklif yaroqsiz',
        text: 'Xona egasidan havolani qayta yuborishni soʻrang.',
      },
      room_full: { title: 'Xona toʻla', text: 'Ishtirokchilar soni chegarasiga yetildi.' },
      forbidden: { title: 'Kirish yopiq', text: 'Siz bu xonadan chiqarilgansiz.' },
      rate_limited: { title: 'Urinishlar juda koʻp', text: 'Biroz kutib, qayta urinib koʻring.' },
      unknown: { title: 'Ulanib boʻlmadi', text: 'Internetni tekshirib, qayta urinib koʻring.' },
    },
    closed: {
      title: 'Xona yakunlandi',
      owner_closed: 'Xona egasi seansni yakunladi.',
      expired: 'Xona vaqti tugagani sababli yopildi.',
      kicked: 'Siz xonadan chiqarildingiz.',
      replaced: 'Xona boshqa varaqda yoki qurilmada ochildi.',
    },
    actionErrors: {
      forbidden: 'Bu amal uchun huquq yetarli emas',
      rate_limited: 'Juda tez. Bir soniya kuting',
      generic: 'Amal bajarilmadi. Qayta urinib koʻring',
    },
  },
  source: {
    label: 'Video havolasi',
    placeholder: 'Havolani qoʻying: serial sahifasi, MP4, HLS, YouTube, Vimeo…',
    apply: 'Tomosha',
    change: 'Videoni almashtirish',
    detected: 'Aniqlandi',
    kinds: {
      file: 'Video fayl',
      hls: 'HLS oqimi',
      dash: 'MPEG-DASH',
      youtube: 'YouTube',
      vimeo: 'Vimeo',
      twitch: 'Twitch',
      rutube: 'Rutube',
      vk: 'VK Video',
      embed: 'Joylashtiriladigan pleyer',
      page: 'Sayt sahifasi',
      unknown: 'Nomaʼlum format',
    },
    status: {
      ready: 'Manba tayyor',
      loading: 'Manba ulanmoqda…',
    },
    errors: {
      invalid_url: {
        title: 'Bu havola emas',
        text: 'https:// bilan boshlanadigan toʻliq manzilni qoʻying.',
      },
      embed_blocked: {
        title: 'Manba joylashtirishni taqiqlaydi',
        text: 'Video egasi uni boshqa saytlarda koʻrishni oʻchirib qoʻygan. Boshqa havolani sinab koʻring.',
      },
      auth_required: {
        title: 'Manba avtorizatsiya talab qiladi',
        text: 'Video login, obuna yoki token bilan yopilgan. VYBE bunday himoyani chetlab oʻtmaydi.',
      },
      unsupported_format: {
        title: 'Format qoʻllab-quvvatlanmaydi',
        text: 'Brauzer bu faylni ijro eta olmaydi. MP4 (H.264), WebM, HLS yoki DASH mos keladi.',
      },
      unavailable: {
        title: 'Video mavjud emas',
        text: 'Fayl topilmadi, oʻchirilgan yoki server boshqa saytlardan ijroga ruxsat bermaydi (CORS).',
      },
      drm: {
        title: 'Video DRM bilan himoyalangan',
        text: 'Himoyalangan kontentni umumiy xonada ijro etib boʻlmaydi.',
      },
      network: {
        title: 'Aloqa uzildi',
        text: 'Videoni yuklab boʻlmayapti. Internetni tekshiring.',
      },
      timeout: {
        title: 'Manba javob bermayapti',
        text: 'Video belgilangan vaqtda yuklanmadi. Havolani tekshiring.',
      },
    },
    capability: {
      auto: 'Avtomatik sinxronlash',
      manual: 'Umumiy taymkod boʻyicha qoʻlda sinxronlash',
      manualPage: 'Qoʻlda sinxronlash (agar sayt joylashtirishga ruxsat bersa)',
      blocked: 'Sayt joylashtirishni taqiqlagan — faqat qoʻlda sinxronlash',
      unknown:
        'Sinxronlash rejimi yuklangandan keyin aniqlanadi: video fayl — avtomatik, sahifa — qoʻlda',
      caveats: {
        rutube:
          'Rutube reklamasi har kimga alohida koʻrsatiladi: u davomida tomoshabin orqada qolishi mumkin, reklama yonida bosilgan pauza uzatilmaydi. Reklamadan keyin VYBE uni umumiy vaqtga qaytaradi.',
      },
      degraded: {
        play: 'Pleer VYBE buyrugʻi bilan ijroni boshlamadi, shuning uchun sizda qoʻlda sinxronlash yoqildi: umumiy taymkod boʻyicha Play tugmasini pleerning oʻzida bosing.',
        pause:
          'Pleer VYBE buyrugʻi bilan toʻxtamadi, shuning uchun sizda umumiy taymkod boʻyicha qoʻlda sinxronlash yoqildi.',
        seek: 'Pleer VYBE buyrugʻi bilan kerakli joyga oʻtmadi, shuning uchun sizda umumiy taymkod boʻyicha qoʻlda sinxronlash yoqildi.',
        time: 'Pleer joriy vaqtni bildirmaydi, shuning uchun sizda umumiy taymkod boʻyicha qoʻlda sinxronlash yoqildi.',
      },
    },
    nextStep:
      'Nima mos keladi: MP4/WebM ga toʻgʻridan-toʻgʻri havola, .m3u8 yoki .mpd oqimi, YouTube, Vimeo, VK Video yoki Rutube videosi.',
    empty: {
      title: 'Video hali tanlanmagan',
      host: 'Havolani yuqoriga qoʻying — VYBE manba turini oʻzi aniqlaydi.',
      guest: 'Boshlovchi tez orada nima koʻrishni tanlaydi.',
    },
    page: {
      blockedTitle: (host: string) => `${host} joylashtirishni taqiqlaydi`,
      blockedText:
        'Sayt oʻz sahifalarini boshqa saytlar ichida koʻrsatishga ruxsat bermaydi va VYBE bu taqiqni chetlab oʻtmaydi.',
      blockedHint:
        'Sahifani saytda oching va quyidagi umumiy taymkod boʻyicha tomosha qiling — yoki avtomatik sinxronlanadigan manbani tanlang: YouTube, Vimeo, VK Video, Rutube yoki video faylga toʻgʻridan-toʻgʻri havola.',
      openSite: 'Saytda ochish',
      watchInTab: 'Alohida varaqda koʻrish',
      backToFrame: 'VYBE ichida koʻrsatish',
      tabTitle: 'Siz alohida varaqda tomosha qilyapsiz',
      tabText:
        'VYBE begona sayt pleyerini boshqarmaydi. Videoni u yerda oʻzingiz ishga tushiring va toʻxtating, quyidagi umumiy taymkodga qarab.',
      frameUnknown:
        'Sahifa koʻrinmayaptimi? Sayt joylashtirishni taqiqlagan boʻlishi mumkin — uni saytda oching.',
      episodeHint: 'Keyingi qism: boshlovchi unga havolani qoʻyadi — u hammada ochiladi.',
    },
    manual: {
      title: 'Qoʻlda sinxronlash',
      roomTime: 'Umumiy taymkod',
      playing: 'ijro etilmoqda',
      paused: 'pauzada',
      countdown: (n: number) => `${n} soniyadan keyin start…`,
      pressPlay: 'Pleyerda ▶ ni bosing',
      start: 'Hamma uchun start',
      pause: 'Hamma uchun pauza',
      setTime: 'Vaqtni belgilash',
      timeLabel: 'Hamma uchun vaqt (dd:ss)',
      timeInvalid: 'Vaqtni 12:34 yoki 1:02:03 koʻrinishida kiriting',
      guestHint: 'Buyruqlarni boshlovchi beradi — taymkod va bildirishnomalarni kuzating.',
      explain:
        'Bu pleyer VYBE ga oʻzini boshqarishga ruxsat bermaydi, shuning uchun pauza va oʻtkazish avtomatik uzatilmaydi. «Hamma uchun start» va 3-2-1 sanogʻidan keyin har kim umumiy taymkodda pleyerda ▶ ni oʻzi bosadi; pauza va oʻtkazish ham shunday.',
      notices: {
        play: (name: string, time: string) => `${name}: ${time} dan hamma uchun start`,
        pause: (name: string, time: string) => `${name}: ${time} da pauza`,
        seek: (name: string, time: string) => `${name}: ${time} ga oʻtkazildi`,
      },
    },
    autoplayBlocked: 'Brauzer avtomatik ijroni toʻxtatdi',
    autoplayAction: 'Tomoshaga qoʻshilish uchun bosing',
  },
  player: {
    play: 'Ijro etish',
    pause: 'Pauza',
    mute: 'Ovozni oʻchirish',
    unmute: 'Ovozni yoqish',
    fullscreen: 'Toʻliq ekran',
    exitFullscreen: 'Toʻliq ekrandan chiqish',
    seek: 'Oʻtkazish',
    volume: 'Ovoz balandligi',
    noControl: 'Ijroni boshlovchi boshqaradi',
    buffering: 'Buferlanmoqda…',
    lag: {
      behind: (s: number) => `Orqada qolish: ${s} soniya`,
      ahead: (s: number) => `Oldinda: ${s} soniya`,
      slowLink: 'sekin yuklanish',
      catchUp: 'Yetib olish',
      sync: 'Sinxronlash',
    },
    react: 'Reaksiya',
  },
  chat: {
    placeholder: 'Xabar…',
    send: 'Yuborish',
    sending: 'Yuborilmoqda…',
    failed: 'Yuborilmadi',
    retry: 'Qayta yuborish',
    empty: 'Hozircha xabarlar yoʻq. Suhbatni boshlang.',
    tooLong: (max: number) => `${max} belgidan oshmasin`,
    system: {
      joined: (name: string) => `${name} qoʻshildi`,
      left: (name: string) => `${name} chiqdi`,
      removed: (name: string) => `${name} xonadan chiqarildi`,
      sourceChanged: (name: string) => `${name} yangi video qoʻydi`,
      roleChanged: (name: string) => `${name} roli oʻzgartirildi`,
    },
    react: 'Reaksiya qoʻshish',
    newMessages: 'Yangi xabarlar',
    newMessagesCount: (n: number) => `Yangi xabarlar · ${n}`,
    unreadCount: (n: number) => `Oʻqilmagan: ${n}`,
    reply: 'Javob berish',
    replyingTo: (name: string) => `${name}ga javob`,
    cancelReply: 'Javobni bekor qilish',
    jumpToOriginal: 'Asl xabarga oʻtish',
    quoteUnavailable: 'Asl xabar endi mavjud emas',
    messageActions: 'Xabar amallari',
    title: 'Chat',
    openChat: 'Chatni ochish',
    hideChat: 'Chatni yashirish',
    showOverVideo: 'Chat video ustida',
    dock: 'Video yoniga mahkamlash',
    floatingNotice: 'Chat video ustidagi oynada ochiq',
  },
  call: {
    title: 'Qoʻngʻiroq',
    micOn: 'Mikrofonni yoqish',
    micOff: 'Mikrofonni oʻchirish',
    camOn: 'Kamerani yoqish',
    camOff: 'Kamerani oʻchirish',
    collapse: 'Yigʻish',
    expand: 'Yoyish',
    devices: 'Qurilmalar',
    microphone: 'Mikrofon',
    camera: 'Kamera',
    defaultDevice: 'Standart',
    dragHint: 'Koʻchirish uchun torting',
    connecting: 'ulanmoqda…',
    failed: 'aloqa yoʻq',
    cameraOff: 'Kamera oʻchiq',
    disabledByRoom: 'Xona sozlamalarida oʻchirilgan',
    errors: {
      denied: {
        mic: 'Mikrofonga ruxsat berilmagan. Brauzer sozlamalarida ruxsat bering (manzil satridagi qulf belgisi).',
        cam: 'Kameraga ruxsat berilmagan. Brauzer sozlamalarida ruxsat bering (manzil satridagi qulf belgisi).',
      },
      not_found: {
        mic: 'Mikrofon topilmadi. Qurilmani ulang va qayta urinib koʻring.',
        cam: 'Kamera topilmadi. Qurilmani ulang va qayta urinib koʻring.',
      },
      in_use: {
        mic: 'Mikrofon boshqa ilova tomonidan band.',
        cam: 'Kamera boshqa ilova tomonidan band.',
      },
      insecure: {
        mic: 'Mikrofon faqat HTTPS orqali ishlaydi.',
        cam: 'Kamera faqat HTTPS orqali ishlaydi.',
      },
      unknown: { mic: 'Mikrofonni yoqib boʻlmadi.', cam: 'Kamerani yoqib boʻlmadi.' },
    },
    peerFailedHint: 'Toʻgʻridan-toʻgʻri ulanib boʻlmadi. Qattiq tarmoqlar uchun TURN server kerak.',
  },
  notFound: { title: 'Sahifa topilmadi', text: 'Bunday sahifa yoʻq. Bosh sahifaga qayting.' },
};
